module.exports = __webpack_public_path__ + "img/i-ban.81d6b27.png";